module.exports = __webpack_public_path__ + "static/media/img-1-spine.3a1f8c31.png";